import createRavenMiddleware from 'raven-for-redux'
import * as redux from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import {createEpicMiddleware} from 'redux-observable'
import UniversalRouter from 'universal-router'

import {rootEpic} from '../rootEpic'
import {rootReducer} from '../rootReducer'
import * as Router from '../router'
import {routes} from '../routes'
import * as Types from './types'

export const createStore = (dependencies: Types.Dependencies) => redux.createStore(
  rootReducer,
  composeWithDevTools(
    redux.applyMiddleware(
      createEpicMiddleware(rootEpic, {dependencies}),
      createRavenMiddleware(dependencies.raven),
    ),
  ),
)

export const router = new (UniversalRouter as any)(routes, {resolveRoute: Router.onEnter})



// WEBPACK FOOTER //
// ./src/app/utils.ts